import { render, staticRenderFns } from "./near-ex.vue?vue&type=template&id=27f0dd05&scoped=true&"
import script from "./near-ex.vue?vue&type=script&lang=js&"
export * from "./near-ex.vue?vue&type=script&lang=js&"
import style0 from "./near-ex.vue?vue&type=style&index=0&id=27f0dd05&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27f0dd05",
  null
  
)

export default component.exports